import Password from './Password';
import withPasswordError from './withPasswordError';

export default withPasswordError(Password);
